module.exports = __webpack_public_path__ + "img/te-mision7.62bf1b4a.png";